
/* injects from baggage-loader */
require('./style.scss');

import React from 'react';
import ReactDatePicker from 'react-datepicker';
import PropTypes from 'prop-types';
import moment from 'moment';

const DatePicker = ({ onlyPast, maxDate, ...rest }) => {
    return <ReactDatePicker
        customInput={null}
        dateFormat="dd-MM-yyyy"
        placeholder="DD-MM-YYYY"
        dropdownMode="scroll"
        locale={moment.locale()}
        maxDate={onlyPast ? new Date() : maxDate}
        {...rest}
    />;
};

DatePicker.propTypes = {
    onlyPast: PropTypes.bool,
};

export default DatePicker;